/** "ANA LÚCIA DE ARAÚJO" → "Ana" */
export function primeiroNome(nome: string | null | undefined) {
  const p = (nome ?? '').trim().split(/\s+/)[0] ?? '';
  return p.charAt(0).toUpperCase() + p.slice(1).toLowerCase();
}

const MINUSCULAS = new Set(['de', 'da', 'do', 'das', 'dos', 'e']);

/** "ANA LÚCIA DE ARAÚJO" → "Ana Lúcia de Araújo" */
export function nomeProprio(nome: string) {
  return nome
    .toLowerCase()
    .split(/\s+/)
    .map((p, i) => (i > 0 && MINUSCULAS.has(p) ? p : p.charAt(0).toUpperCase() + p.slice(1)))
    .join(' ');
}

export function dataBr(iso: string | null | undefined, comHora = false) {
  if (!iso) return '–';
  const d = new Date(iso);
  return comHora
    ? d.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })
    : d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'long' });
}

/** Dias inteiros até a data (negativo se já passou). */
export function diasAte(iso: string) {
  return Math.ceil((new Date(iso).getTime() - Date.now()) / 86_400_000);
}
